/**
 * Tiny admin API client — talks to /api/admin/* endpoints.
 * JWT is stored in localStorage under `rcd_admin_token`.
 */
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = 'rcd_admin_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY) || '';
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

export const login = async (password) => {
  const res = await axios.post(`${API}/api/admin/login`, { password });
  setToken(res.data.token);
  return res.data;
};

export const me = async () => {
  const res = await axios.get(`${API}/api/admin/me`, { headers: authHeaders() });
  return res.data;
};

export const listAllClients = async () => {
  const res = await axios.get(`${API}/api/clients`);
  return res.data;
};

export const listClients = async (category) => {
  const res = await axios.get(`${API}/api/clients`, { params: category ? { category } : {} });
  return res.data;
};

export const createClient = async (name, category) => {
  const res = await axios.post(`${API}/api/admin/clients`, { name, category }, { headers: authHeaders() });
  return res.data;
};

export const deleteClient = async (id) => {
  const res = await axios.delete(`${API}/api/admin/clients/${id}`, { headers: authHeaders() });
  return res.data;
};

export const uploadPhotos = async (clientId, files) => {
  const form = new FormData();
  files.forEach(f => form.append('files', f));
  const res = await axios.post(
    `${API}/api/admin/clients/${clientId}/photos`,
    form,
    { headers: { ...authHeaders(), 'Content-Type': 'multipart/form-data' } }
  );
  return res.data;
};

export const deletePhoto = async (clientId, photoId) => {
  const res = await axios.delete(
    `${API}/api/admin/clients/${clientId}/photos/${photoId}`,
    { headers: authHeaders() }
  );
  return res.data;
};

export const photoUrl = (storagePathOrUrl) => {
  if (!storagePathOrUrl) return '';
  if (storagePathOrUrl.startsWith('http')) return storagePathOrUrl;
  if (storagePathOrUrl.startsWith('/api/')) return `${API}${storagePathOrUrl}`;
  return `${API}/api/files/${storagePathOrUrl}`;
};

export const CATEGORIES = [
  { id: 'residential', label: 'Residential Projects' },
  { id: 'events',      label: 'Events Projects' },
  { id: 'others',      label: 'Others Institutions' },
  { id: 'gifting',     label: 'Gifting Projects' }
];
